<template>
	<section>
		<div class='dropdown'>
			<input type="text" class="form-control form-control-sm p-3 mt-1" placeholder="🔎 Busque por telefone ou nome" v-model="keyword"/>
			<div id='groupSession' class="mt-1">
				<input id="myclientsSession-input-dropdown" type="checkbox" checked>
				<label for="myclientsSession-input-dropdown" class="animate">Sessão Expirada<span class="attCount">{{ arraySession.length }}</span></label>				
				<ul id='myclients'>
					<section v-for="item in arraySession" :key="item.protocol">
						<div class="myclientscreated">
							<li class="animate" :class="item.key == selected ? 'selected' : ''">
								<item-todas-mensagens class="custom-message p-2"
									@click.native="setCurrentConversa(item.key), selectConversa(item.key)"
									:client_id="item.key"
									:selected="selected"
									:avatar_url="item.avatar"
									:time="item.time"
									:nome="item.nome"
									:notify="item.notify"
									:fila="item.fila === 'entrante' ? 'Ativo' : item.fila"
									:tipo="item.tipo === 'entrante' ? 'ativo' : 'receptivo'"
									:channel="item.channel"
									:operador="item.operador"
									:prev_text="item.text_prev"
									:unreadMessages="getUnreadMessages">
								</item-todas-mensagens>
							</li>
						</div>
					</section>
				</ul>
			</div>
			<div id='groupClient' class="mt-1">
				<input id="myclients-input-dropdown" type="checkbox" checked>
				<label for="myclients-input-dropdown" class="animate">Clientes Receptivos <span class="attCount">{{ arrayOperator.length }}</span></label>				
				<ul id='myclients'>
					<section v-for="item in arrayOperator" :key="item.protocol">
						<div class="myclientscreated">
							<li class="animate" :class="item.key == selected ? 'selected' : ''">
								<item-todas-mensagens class="custom-message p-2"
									@click.native="setCurrentConversa(item.key), selectConversa(item.key)"
									:client_id="item.key"
									:selected="selected"
									:avatar_url="item.avatar"
									:time="item.time"
									:nome="item.nome"
									:notify="item.notify"
									:fila="item.fila"
									tipo="receptivo"
									:channel="item.channel"
									:operador="item.operador"
									:prev_text="item.text_prev"
									:unreadMessages="getUnreadMessages">
								</item-todas-mensagens>
							</li>
						</div>
					</section>
				</ul>
			</div>

			<div id='groupAtivos' class="mt-1">
				<input id="myclientsativo-input-dropdown" type="checkbox" checked>

				<label for="myclientsativo-input-dropdown" class="animate">Clientes Ativos <span class="attCount">{{ arrayActive.length }}</span></label>

				<ul id='myclientsativos'>
					<section v-for="item in arrayActive" :key="item.protocol">
						<div class="myclientscreated">
							<li class=" animate" :class="item.key == selected ? 'selected' : ''">
								<item-todas-mensagens class="custom-message p-2"
								@click.native="setCurrentConversa(item.key), selectConversa(item.key)"
									:client_id="item.key"
									:selected="selected"
									:avatar_url="item.avatar"
									:time="item.time"
									:nome="item.nome"
									:notify="item.notify"
									fila="Ativo"
									tipo="ativo"
									:operador="item.operador"
									:prev_text="item.text_prev"
									:unreadMessages="getUnreadMessages">
								</item-todas-mensagens>
							</li>
						</div>
					</section>
				</ul>
			</div>

			<div id="groupQueue" class="mt-1">
				<input id="queueclients-input-dropdown" type="checkbox" checked>

				<label for="queueclients-input-dropdown" class="animate">Fila de Atendimento <span class="attCount">{{ arrayQueue.length }}</span></label>

				<ul id='queueClients'>
					<section v-for="(item) in arrayQueue" :key="item.protocol">
						<section v-if="item.operador == ''">
							<li class="animate ">
								<section>
									<item-todas-mensagens class="custom-message p-2"
										@click.native="setCurrentConversa(item.key), selectConversa(item.key)"
										:avatar_url="item.avatar"
										:client_id="item.key"
										:time="item.time"
										:nome="item.nome"
										:notify="item.notify"
										:fila="item.fila"
										:channel="item.channel"
										tipo="receptivo"
										:operador="item.operador"
										:prev_text="item.text_prev"
										:unreadMessages="getUnreadMessages">
									</item-todas-mensagens>
								</section>
							</li>
						</section>
					</section>
				</ul>
			</div>

		</div>
	</section>
</template>

<script>
import {mapGetters, mapMutations, mapActions} from 'vuex';
import ItemTodasMensagens from "./ItemTodasMensagens";
import notificationService from "../../../modules/notification"
const audio = new Audio('/sounds/button-09a.mp3');
const audio_notificacao = new Audio('/sounds/livechat.mp3');

export default {
	name: "TodasMenssagensChat",
	components: {ItemTodasMensagens},
	data: function() {
		return {
			selected: '',
			totalOperator: 0,
			totalActive: 0,
			totalQueue: 0,
			keyword: '',
			tempArrayOperator: [],
			tempArrayActive: [],
			tempArrayQueue: [],
			tempArraySession: [],
			newMessages: 0,
			notified: {},
			isPageActive: true
		}
	},
	computed: {
		...mapGetters(['getCurrentMensagens', 'getExtension', 'getConversasChat', 'getMessagesNotRead', 'getItemMessage', 'getUnreadMessages', 'getCurrentConversaIndex', 'getTemCurrentConversa']),
		arrayOperator(){
			let array;
			if(this.keyword != ''){
				array = this.tempArrayOperator.filter(el => {
					const phone = el.key.split('@')[0];
					const nomeLower = el.nome.toLowerCase();
					const keywordLower = this.keyword.toLowerCase();
					const phoneLower = phone.toLowerCase();
					if(nomeLower.includes(keywordLower) || phoneLower.includes(keywordLower)) return el;
				})
			} else {
				array = this.tempArrayOperator;
			}
			return array.sort((a, b) => {
				if(a.time < b.time){
					return 1;
				}else if(a.time > b.time){
					return -1;
				} else {
					return 0;
				}
			});
		},
		arrayActive(){
			let array;
			if(this.keyword != ''){
				array = this.tempArrayActive.filter(el => {
					const phone = el.key.split('@')[0];
					const nomeLower = el.nome.toLowerCase();
					const keywordLower = this.keyword.toLowerCase();
					const phoneLower = phone.toLowerCase();
					if(nomeLower.includes(keywordLower) || phoneLower.includes(keywordLower)) return el;
				})
			} else {
				array = this.tempArrayActive;
			}
			return array.sort((a, b) => {
				if(a.time < b.time){
					return 1;
				}else if(a.time > b.time){
					return -1;
				} else {
					return 0;
				}
			});
		},
		arrayQueue(){
			let array;
			if(this.keyword != ''){
				array = this.tempArrayQueue.filter(el => {
					const phone = el.key.split('@')[0];
					const nomeLower = el.nome.toLowerCase();
					const keywordLower = this.keyword.toLowerCase();
					const phoneLower = phone.toLowerCase();
					if(nomeLower.includes(keywordLower) || phoneLower.includes(keywordLower)) return el;
				})
			} else {
				array = this.tempArrayQueue;
			}
			return array.sort((a, b) => {
				if(a.created_at < b.created_at){
					return -1;
				}else if(a.created_at > b.created_at){
					return 1;
				} else {
					return 0;
				}
			});
		},
		arraySession(){
			let array;
			if(this.keyword != ''){
				array = this.tempArraySession.filter(el => {
					const phone = el.key.split('@')[0];
					const nomeLower = el.nome.toLowerCase();
					const keywordLower = this.keyword.toLowerCase();
					const phoneLower = phone.toLowerCase();
					if(nomeLower.includes(keywordLower) || phoneLower.includes(keywordLower)) return el;
				})
			} else {
				array = this.tempArraySession;
			}
			return array.sort((a, b) => {
				if(a.created_at < b.created_at){
					return 1;
				}else if(a.created_at > b.created_at){
					return -1;
				} else {
					return 0;
				}
			});
		},
		unreadMessages() {				
		    if (typeof this.getUnreadMessages === 'object' && this.getUnreadMessages !== null) {
		        return Object.values(this.getUnreadMessages).some(el => el > 0);
		    } else {
		        return null;
		    }
		}
	},
	methods: {
		...mapMutations(['setCurrentConversa']),
		...mapActions(['joinQueue','newEntry','removeClient', 'operatorInUse','disconnect', 'resetNotify', 'markAsRead']),

		// Solicita permissão para notificações
		requestNotificationPermission() {
			if (Notification.permission === 'default') {
			Notification.requestPermission();
			}
		},
		// Cria e exibe uma notificação
		showNotification(title, options) {
			if (Notification.permission === 'granted') {
			new Notification(title, options);
			}
		},

		totalNewMessages(name, avatar = null, count, key, isQueue, queue) {
			if(!this.isPageActive || !this.getTemCurrentConversa || !this.getTemCurrentConversa[key]) {
				audio_notificacao.play();
				if(isQueue){
					const bodyText = `${name} está aguardando na fila ${queue}`
					const countMsg = count > 1 ? ` (${count} novas mensagens)` : ` (1 nova mensagem)`;
					this.showNotification('Nova mensagem na fila!', {
						body: bodyText + countMsg,
						icon: avatar ? avatar : '/imgs/advance-logo.png'
					});
				} else {
					this.showNotification('Você tem mensagens não lidas!', {
						body: count > 1 ? `Você tem ${count} novas mensagens de ` + name : `Você tem uma nova mensagem de ` + name,
						icon: avatar ? avatar : '/imgs/advance-logo.png'
					});
				}
			} else if(this.isPageActive && this.getTemCurrentConversa && this.getTemCurrentConversa[key]) {
				this.notified[key] = 0;
				this.markAsRead(key);
			}
		},
		selectConversa(key) {
			this.selected = key;
		},	

		handleCurrentConversa(key) {
        	this.resetNotify(key);
        	this.selected = key;
    	},
		getChat(val) {
			this.tempArrayOperator = [];
			this.tempArrayActive = [];
			this.tempArrayQueue = [];
			this.tempArraySession = [];
			if (val.length > 0) {
				val.forEach((el) => {
					if(el.operador != '' && el.fila !== 'entrante' && el.text_prev !== "Sessão da conversa expirou!") {
						this.tempArrayOperator.push(el);
					} else if(el.operador != '' && el.text_prev === "Sessão da conversa expirou!") {
						this.tempArraySession.push(el);
					} else if(el.fila == 'entrante' && el.text_prev !== "Sessão da conversa expirou!") {
						this.tempArrayActive.push(el);
					} else {
						this.tempArrayQueue.push(el);
					}
				})
			}
		},
		handleFocus() {
      		this.isPageActive = true;
    	},
    	handleBlur() {
			this.isPageActive = false;
    	},
	},
	watch: {
		getCurrentMensagens: {
			handler(val) {
				this.getChat(val);
			}
		},
		getUnreadMessages: {
			handler(val) {
				console.log('getUnreadMessages: ', val)
				setTimeout(() => {
					this.newMessages = 0;
					if(typeof val === 'object' && val !== null) {
						Object.entries(val).forEach(([key, value]) => {
							const found = this.tempArrayOperator.find(el => el.key === key) || this.tempArrayActive.find(el => el.key === key);
							const foundQueue = this.tempArrayQueue.find(el => el.key === key);
							if(value > 0){
								this.newMessages += value;
								if(!this.notified[key] || this.notified[key] !== value) {
									this.notified[key] = value;
									if(found){
										this.totalNewMessages(found.nome, found.avatar, value, key, false);
									} else if(foundQueue){
										this.totalNewMessages(foundQueue.nome, foundQueue.avatar, value, key, true, foundQueue.fila);
									}
								}
							}
						});
					}
					if (this.newMessages > 0) {
					window.document.title = '(' + this.newMessages + ') Tela do Operador - Advance Management'
					} else {
						window.document.title = 'Tela do Operador - Advance Management';
					}
				}, 500);
			},
			deep: true,
		},
		getCurrentConversaIndex: {
			handler(val) {
				if(val === '') this.selected = '';
			},
		},
		isPageActive(val){
      		if(val && this.getTemCurrentConversa) {
				// Marcando todas as mensagens da conversa que está na tela como lida ao pegar foco na tela
				const key = Object.keys(this.getTemCurrentConversa)[0];
				this.notified[key] = 0;
				this.markAsRead(key);
	  		}
    	}
	},
	mounted() {
		const x = user.getId();
		this.requestNotificationPermission();
		this.newEntry();
		this.removeClient();
		this.operatorInUse();
		window.addEventListener("focus", this.handleFocus);
    	window.addEventListener("blur", this.handleBlur);
    },
}
</script>

<style scoped>
	.custom-message {
		cursor: pointer;
		padding: 0px !important;
	}

	*{
		padding: 0;
		margin: 0;
		font-family: 'Lato', sans-serif;
		box-sizing: border-box;
	}
	.float-right{
		float: right;
	}
	.fa{
		font-size: .8em;
		line-height: 22px !important;
	}
	.attCount{
		background-color: #599ca8;
    	padding: 3px 6px;
    	border-radius: 5px;
    	font-weight: bold;
		margin-left: 10px;
	}
	.dropdown{max-height: 450px}
	.dropdown label, .dropdown ul li{
		display: block;
		/* width: 200px; */
		background: #ECF0F1;
		padding: 8px 10px;
		margin: 2px;
		border: 1px solid lightgray
	}

	.dropdown label:hover, .dropdown ul li:hover{
		background: #1c869a;
		color: white;
		cursor: pointer;
	}

	.dropdown label{
		color: #1c869a;
		border-left: 4px solid #1c869a;
		border-radius: 0 5px 0 0;
		position: relative;
		z-index: 2;
	}

	.dropdown #myclients-input-dropdown{
		display: none;
	}

	.dropdown #myclientsSession-input-dropdown{
		display: none;
	}
	.dropdown #queueclients-input-dropdown{
		display: none;
	}
	.dropdown #myclientsativo-input-dropdown{
		display: none;
	}

	input:checked + label{
		background: #1c869a;
		color: white;
	}

	#groupClient input ~ ul{
		position: relative;
		visibility: hidden;
		display:none;
		opacity: 0;
		top: -20px;
		z-index: 1;
	}

	#groupClient input:checked ~ ul{
		visibility: visible;
		display: block;
		opacity: 1;
		top: 0;
	}

	#groupSession input ~ ul{
		position: relative;
		visibility: hidden;
		display:none;
		opacity: 0;
		top: -20px;
		z-index: 1;
	}

	#groupSession input:checked ~ ul{
		visibility: visible;
		display: block;
		opacity: 1;
		top: 0;
	}


	#groupQueue input ~ ul{
		position: relative;
		visibility: hidden;
		display:none;
		opacity: 0;
		top: -20px;
		z-index: 1;
	}

	#groupQueue input:checked ~ ul{
		visibility: visible;
		display: block;
		opacity: 1;
		top: 0;
	}

	#groupAtivos input ~ ul{
		position: relative;
		visibility: hidden;
		display:none;
		opacity: 0;
		top: -20px;
		z-index: 1;
	}

	#groupAtivos input:checked ~ ul{
		visibility: visible;
		display: block;
		opacity: 1;
		top: 0;
	}

	.animate{
		font-weight: bold;
		-webkit-transition: all .3s;
		-moz-transition: all .3s;
		-ms-transition: all .3s;
		-ms-transition: all .3s;
		transition: all .3s;
		backface-visibility:hidden;
		-webkit-backface-visibility:hidden; /* Chrome and Safari */
		-moz-backface-visibility:hidden; /* Firefox */
		-ms-backface-visibility:hidden; /* Internet Explorer */
	}
	.selected {
        background-color: #c6d6d9 !important;
        box-shadow: inset 0px 0px 5px 2px #1c869a;
    }
</style>